
import { takeLatest, call, put, select } from 'redux-saga/effects';
import { bookingAvailabilityActionTypes } from './bookingAvailabilityTypes';
import { bookingAvailabilityApiResponseError, bookingAvailabilityApiResponseSuccess } from './bookingAvailabilityActions'
import { showErrorNotification, showSuccessNotification } from "../../helpers/NotificationContext";
import { getAvailableRoomsApi } from 'src/api/bookingAvailability';
import { uiChatReducerActionTypes } from '../uiChatReducer/uiChatTypes';
import { uiChatApiResponseSuccess } from '../uiChatReducer/uiChatActions';




function* getAvailableRoomsSaga(action: any) {
    try {
        console.log("[getAvailableRoomsSaga] action.payload", action.payload);

        const payload = action.payload;
        console.log("getAvailableRoomsSaga sending payload to api:", payload);
        const response = yield call(getAvailableRoomsApi, payload);
        console.log("Backend response from getAvailableRoomsSaga: ", response);
        yield put(bookingAvailabilityApiResponseSuccess(bookingAvailabilityActionTypes.GET_AVAILABLE_ROOMS, response));

        const payload_for_get = {
            uiComponent: {
                type: "DailyBookingsDashboard",
                props: response
            },
            intent: {
                "customer_request": "आज सुबह की सारी बुकिंग डिटेल्स दिखाओ?",
                "category": "ERP → Query",
                "intent": "INTENT_QUERY_BOOKINGS_FOR_TODAY",
                "intent_type": "existing",
                "system_message": "supported"
            }
        }

        yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.GET_SYSTEM_RESPONSE, payload_for_get));
        showSuccessNotification(`🚀 Details fetched successfully!`);

    } catch (error: any) {
        console.error(" getAvailableRoomsSaga Saga error fetching available rooms:", error.message);
        yield put(bookingAvailabilityApiResponseError(bookingAvailabilityActionTypes.GET_AVAILABLE_ROOMS, error.message));
        showErrorNotification("Execution failed: " + error.message);
    }
}





export default function* bookingAvailabilitySaga() {
    yield takeLatest(bookingAvailabilityActionTypes.GET_AVAILABLE_ROOMS, getAvailableRoomsSaga);
    // yield takeLatest(uiChatReducerActionTypes.GET_SYSTEM_RESPONSE, getAvailableRoomsSaga);


}
